import { combineData, data, type ObservableValue } from '@amazon/vinyl-observable'
import { jsx } from '@amazon/vinyl-tsx'
import { getString } from '@/util/i18n/bundle.generated'

/** Sticky "You are offline" notice: stays while the network is bad, a click dismisses it until the next outage. */
export function OfflineToast(props: { goodNetwork$: ObservableValue<boolean> }) {
    const dismissed$ = data(false)
    const visible$ = combineData({ good: props.goodNetwork$, dismissed: dismissed$ }).map(
        ({ good, dismissed }) => !good && !dismissed
    )
    return (
        <button
            type="button"
            className="offlineToast"
            role="status"
            visible={visible$}
            onclick={() => {
                dismissed$.value = true
            }}
            onConnect={() =>
                props.goodNetwork$.onData((good) => {
                    if (good) dismissed$.value = false
                })
            }
        >
            {getString('dmusic_network_error_toast')}
        </button>
    )
}
